import { apiClient } from "../../api/apiClient";

export const fetchEstateByIdAsync = (estateId) =>
  apiClient().get(`/estates/${estateId}`);
